import React, { useState, useRef } from 'react';

const FONT = '"Nunito", "Baloo 2", sans-serif';

/** G5: Example sentence with blank → type the missing word */
export default function FillInBlank({ roundData, onAnswer, palette: P, disabled }) {
  const prompt = roundData.prompt || {};
  const answer = roundData.answer_key || '';
  const [input, setInput] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const inputRef = useRef(null);

  const checkAnswer = (text) => {
    const typed = text.trim().toLowerCase();
    const expected = answer.toLowerCase();
    // Exact match or Levenshtein distance ≤ 1
    if (typed === expected) return true;
    if (Math.abs(typed.length - expected.length) > 1) return false;
    let diff = 0;
    const maxLen = Math.max(typed.length, expected.length);
    for (let i = 0; i < maxLen; i++) {
      if (typed[i] !== expected[i]) diff++;
      if (diff > 1) return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (disabled || showResult || !input.trim()) return;
    const correct = checkAnswer(input);
    setIsCorrect(correct);
    setShowResult(true);
    setTimeout(() => onAnswer(correct, input.trim()), correct ? 700 : 1400);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, width: '100%', maxWidth: 500, margin: '0 auto', fontFamily: FONT }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: P.mutedText }}>
        Điền từ còn thiếu vào câu
      </div>

      {prompt.hint_vi && (
        <div style={{ fontSize: 16, fontWeight: 700, color: P.coral }}>
          Gợi ý: {prompt.hint_vi}
        </div>
      )}

      {/* Sentence with blank */}
      <div style={{
        fontSize: 20, fontWeight: 600, color: P.ink, lineHeight: 1.6,
        background: '#F8F9FA', padding: '20px 24px', borderRadius: 14,
        border: `2px solid ${P.ink}`, boxShadow: `0 3px 0 ${P.ink}`,
        width: '100%', textAlign: 'center',
      }}>
        {(prompt.sentence || '').split('____').map((part, i, arr) => (
          <React.Fragment key={i}>
            {part}
            {i < arr.length - 1 && (
              <span style={{
                display: 'inline-block', borderBottom: `3px solid ${P.coral}`,
                minWidth: 80, margin: '0 4px',
              }}>
                {input && <span style={{ color: P.coral, fontWeight: 800 }}>{input}</span>}
              </span>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Input */}
      <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', gap: 10 }}>
        <input
          ref={inputRef}
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          disabled={disabled || showResult}
          placeholder="Gõ từ vào đây..."
          autoFocus
          autoComplete="off"
          autoCapitalize="off"
          style={{
            flex: 1, padding: '14px 18px', fontSize: 18, fontWeight: 700,
            fontFamily: FONT, borderRadius: 12,
            border: `2.5px solid ${showResult ? (isCorrect ? '#2ECC71' : '#E74C3C') : P.ink}`,
            boxShadow: `0 3px 0 ${showResult ? (isCorrect ? '#27AE60' : '#C0392B') : P.ink}`,
            outline: 'none', color: P.ink,
          }}
        />
        <button type="submit" disabled={disabled || showResult || !input.trim()}
          style={{
            padding: '14px 24px', borderRadius: 12, fontSize: 16, fontWeight: 800,
            fontFamily: FONT, border: `2.5px solid ${P.ink}`,
            boxShadow: `0 3px 0 ${P.ink}`,
            background: P.accent, color: P.ink,
            cursor: disabled || showResult ? 'default' : 'pointer',
          }}>
          OK
        </button>
      </form>

      {showResult && (
        <div style={{ fontSize: 20, fontWeight: 800, color: isCorrect ? '#2ECC71' : '#E74C3C' }}>
          {isCorrect ? '✓ Đúng rồi!' : `✗ Đáp án: ${answer}`}
        </div>
      )}
    </div>
  );
}
